/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

/**
 * Used as a default value for the height of each dropdown option.
 */
export const OPTION_HEIGHT = 30;

/**
 * Used as a default value for the height of the list of dropdown options.
 */
export const MAX_OPTIONS_LIST_HEIGHT = 195;
